/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { IdpGroup } from '../models/IdpGroup';

export class ListIdpGroupsResponse {
  /**
  * List of IDP groups.
  */
  'groups': Array<IdpGroup>;
  /**
  * Total number of IDP groups.
  */
  'totalCount'?: number;
  /**
  * Token to retrieve the next page of results.
  */
  'nextToken'?: string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "groups",
      "baseName": "groups",
      "type": "Array<IdpGroup>",
      "format": ""
    },
    {
      "name": "totalCount",
      "baseName": "totalCount",
      "type": "number",
      "format": ""
    },
    {
      "name": "nextToken",
      "baseName": "nextToken",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return ListIdpGroupsResponse.attributeTypeMap;
  }

  public constructor() {
  }
}

